import styled from "styled-components"
import { Colors } from "styles/app-styles"

export const DirtyNote_s = styled.span`
  background: ${Colors.denim};
  border-radius: 50%;
  margin-left: 4px;
  height: 8px;
  position: absolute;
  width: 8px;
`

export const NotesEdit_s = styled.div`
  margin-top: 14px;
  textarea {
    border: none;
    color: ${Colors.blackPearl};
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    outline: 1px solid ${Colors.towerGrey};
    resize: both;
    min-height: 260px;
    min-width: 500px;
    padding: 8px;
    width: 100%;
  }
`